import { SVG, SVGProps } from './svg'

export function IconCandleBarHeikinAshi(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path fillRule="evenodd" d="M13 0h-2v6H8v17h8V6h-3V0Zm1 8h-4v13h4V8Z" />
    </SVG>
  )
}
